import { PropsWithChildren } from "react"
import cn from "classnames"

export function VideoUserName({ children, className }: PropsWithChildren<{ className?: string }>) {
    return (
        <div className={cn("video-user-name video-window-information", className)}>{children}</div>
    )
}
